import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BusinessState } from './business.reducer';

export const selectBusinessState = createFeatureSelector<BusinessState>('business');

export const selectAllBusinesses = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.businesses
);

export const selectFilteredBusinesses = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.filteredBusinesses
);

export const selectBusinessFilters = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.filters
);

export const selectBusinessLoading = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.isLoading
);

export const selectBusinessLoadingMore = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.isLoadingMore
);

export const selectBusinessError = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.error
);

export const selectHasMoreBusinesses = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.hasMore
);

export const selectCurrentZipCode = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.currentZipCode
);

export const selectBusinessTotalCount = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.totalCount
);

export const selectBusinessTotalPages = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.totalPages
);

export const selectBusinessCurrentPage = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.currentPage
);

export const selectSearchLatitude = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.searchLatitude
);

export const selectSearchLongitude = createSelector(
  selectBusinessState,
  (state: BusinessState) => state.searchLongitude
);

